import moment from 'moment';

const variables = ({ teamId, keyword, campValue, adSetValue }) => {
  const params = {
    limit: 20,
    offset: 0,
    where: {
      deleted_at: null,
      team_id: teamId,
      or: {
        name: { isubstring: keyword },
        'id::TEXT': { isubstring: keyword },
      },
    },
  };
  if (campValue) {
    Object.assign(params.where, {
      campaign_id: campValue,
    });
  }
  if (adSetValue) {
    Object.assign(params.where, {
      ad_set_id: adSetValue,
    });
  }
  return params;
};

export const variablesTeamMember = ({ teamId, keyword }) => {
  const params = {
    limit: 20,
    offset: 0,
    where: {
      deleted_at: null,
      team_id: teamId,
      '$"user".name$': { isubstring: keyword },
    },
  };
  return params;
};

export const variablesSocmed = ({ teamId, socmedType, keyword }) => {
  const params = {
    limit: 20,
    offset: 0,
    where: {
      team_id: teamId,
      deleted_at: null,
      type: socmedType,
      username: { isubstring: keyword },
      // active_status: statusFilter,
    },
  };
  if (socmedType === null) {
    delete params.where.type;
  }
  return params;
};

export const variablesIntegrator = ({ keyword, teamId }) => {
  const params = {
    limit: 20,
    offset: 0,
    where: {
      deleted_at: null,
      team_id: teamId,
      or: {
        '$"ad".name$': { isubstring: keyword },
        'id::TEXT': { isubstring: keyword },
      },
    },
  };
  return params;
};

export const initialValues = (searchQuery) => {
  return {
    campaign_id: searchQuery?.campaign_id,
    ad_set_id: searchQuery?.ad_set_id,
    ad_id: searchQuery?.ad_id,
    integrator_id: searchQuery?.integrator_id,
    type: searchQuery?.type,
    user_socmed_id: searchQuery?.user_socmed_id,
    start_date: searchQuery?.start_date
      ? moment(searchQuery?.start_date)
      : null,
    end_date: searchQuery?.end_date ? moment(searchQuery?.end_date) : null,
    created_by_id: searchQuery?.created_by_id,
    approved_by_id: searchQuery?.approved_by_id,
  };
};

export const onReset = (form) => {
  form.setFieldsValue({
    campaign_id: null,
    ad_set_id: null,
    ad_id: null,
    integrator_id: null,
    type: null,
    user_socmed_id: null,
    start_date: null,
    end_date: null,
    created_by_id: null,
    approved_by_id: null,
  });
};

export default variables;
